import React from "react";
import dayjs from "dayjs";

export default function BlockchainDetailModal({ isOpen, onClose, bcData }) {
    if (!isOpen || !bcData) return null;

    const parseValueStr = (valueStr) => {
        try {
            return JSON.parse(valueStr);
        } catch (e) {
            return null;
        }
    };

    return (
        <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{
                zIndex: 9999,
                background: "rgba(0,0,0,0.5)",
                padding: "15px"
            }}
        >
            <div
                className="bg-white rounded-3 shadow w-100 d-flex flex-column"
                style={{
                    maxWidth: "500px",
                    maxHeight: "85vh",
                    overflow: "hidden"
                }}
            >
                <div className="p-3 border-bottom d-flex align-items-center justify-content-between bg-light">
                    <span className="fw-bold text-dark fs-6">Transaction Details</span>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={onClose}
                    />
                </div>

                <div className="p-3 flex-grow-1 overflow-auto" style={{ fontSize: "13px", lineHeight: "1.5" }}>
                    <div className="mb-3 p-2 rounded" style={{ background: "#F1F5F9" }}>
                        <div className="mb-1">
                            <strong>Tx Hash:</strong>{" "}
                            <span className="text-secondary" style={{ wordBreak: "break-all", fontFamily: "monospace" }}>
                                {bcData.tx_id}
                            </span>
                        </div>
                        <div className="mb-1">
                            <strong>Block No:</strong> <span className="text-secondary">{bcData.blockNumber}</span>
                        </div>
                        <div className="mb-1">
                            <strong>Time:</strong>{" "}
                            <span className="text-secondary">
                                {dayjs(bcData.timestampISO).format("YYYY-MM-DD HH:mm:ss")}
                            </span>
                        </div>
                        <div className="mb-1">
                            <strong>From:</strong>{" "}
                            <span className="text-secondary" style={{ wordBreak: "break-all", fontFamily: "monospace" }}>
                                {bcData.from}
                            </span>
                        </div>
                        <div className="mb-1">
                            <strong>To:</strong>{" "}
                            <span className="text-secondary" style={{ wordBreak: "break-all", fontFamily: "monospace" }}>
                                {bcData.to}
                            </span>
                        </div>
                    </div>

                    <div className="mt-3">
                        <span className="fw-bold d-block mb-2 text-dark border-bottom pb-1">value</span>
                        {parseValueStr(bcData.valueStr) ? (
                            <div className="p-2 border bg-light rounded text-secondary" style={{ fontSize: "11px", overflowX: "auto" }}>
                                {bcData.valueStr}
                            </div>
                        ) : (
                            <pre className="p-2 border bg-light rounded text-secondary" style={{ fontSize: "11px", overflowX: "auto" }}>
                                {bcData.valueStr}
                            </pre>
                        )}
                    </div>
                </div>

                <div className="p-3 border-top d-flex justify-content-end bg-light">
                    <button
                        type="button"
                        className="btn btn-secondary btn-sm px-4 fw-bold"
                        onClick={onClose}
                    >
                        닫기
                    </button>
                </div>
            </div>
        </div>
    );
}